<template>
    <div id="app">
        <loading v-if="showLoading"/>
        <screenAd v-if="visitAd" :timer="0" @done="visitAd=false"/>
        <returnButton v-show="showReturn"/>
        <transition :name="transitionName">
            <router-view/>
        </transition>
        <bottomNavBar v-if="showBottomTool"/>
    </div>
</template>

<script>
import loading from './components/loading.vue'
import screenAd from './components/screenAd.vue'
import returnButton from './components/returnButton.vue'
import bottomNavBar from './components/bottomNavBar.vue'
export default {
    data () {
        return {
            visitAd: false
        }
    },
    components: {
        loading,
        screenAd,
        returnButton,
        bottomNavBar
    },
    computed: {
        showReturn () {
            return this.$store.state.showReturn
        },
        showLoading () {
            return this.$store.state.showLoading
        },
        showBottomTool () {
            return this.$store.state.showToolBar
        },
        transitionName () {
            return this.$store.state.transitionName
        }
    },
    watch: {
        '$store.state.title' (title) {
            if (navigator.userAgent.match(/Alipay/i)) {
                window.AlipayJSBridge.call('setTitle', {
                    title
                })
            } else {
                document.title = title
            }
        }
    }
}
</script>
